import {
  US_ASSOCIATED_STATES,
  US_DOMESTIC_COUNTRIES,
  US_MILITARY_CITIES,
  US_MILITARY_REGIONS,
} from '../constants';

type Address = {
  city: string;
  regionCode: string;
  countryCode: string;
};

export function isMilitaryAddress(addresses: Omit<Address, 'countryCode'>[]): boolean {
  return addresses.some(
    ({ city, regionCode }) =>
      (regionCode && US_MILITARY_REGIONS.includes(regionCode.toUpperCase())) ||
      (city && US_MILITARY_CITIES.includes(city.toUpperCase())),
  );
}

export function isInternational(addresses: Address[]): boolean {
  return addresses.some(
    ({ countryCode }) => countryCode && !US_DOMESTIC_COUNTRIES.includes(countryCode.toUpperCase()),
  );
}

export function isAssociatedState(addresses: Pick<Address, 'regionCode'>[]): boolean {
  return addresses.some(
    ({ regionCode }) => regionCode && US_ASSOCIATED_STATES.includes(regionCode.toUpperCase()),
  );
}

/**
 * defines if address is military, international (not PR, US, VI) or associated state
 */
export default function isMilitaryInternationalOrAssociated(addresses: Address[]): boolean {
  return isMilitaryAddress(addresses) || isInternational(addresses) || isAssociatedState(addresses);
}
